'use strict';

export const BEFORE = 'BEFORE';
export const AFTER = 'AFTER';

export function allOptions() {
    return [
        BEFORE, AFTER
    ];
}